
export const appendQueryParamToUrl = (
    currentUrl,
    paramName,
    value
) => {
    if (!currentUrl) return "";
    
    const url = new URL(currentUrl);
    url.searchParams.set(paramName, value);
    return url.toString();
};

export const appendMultipleQueryParamsToUrl = (
    currentUrl,
    params
) => {
    if (!currentUrl) return "";
    
    let finalUrl = currentUrl;
    params.forEach((pd) => {
        finalUrl = appendQueryParamToUrl(finalUrl, pd.paramName, pd.value);
    });

    return finalUrl;
};